export default {
    init() {
        $('.group_leaders_logout').on('click', function(ev) {
            ev.preventDefault();
            ev.stopPropagation();
            var logout_link = this;
            jQuery.ajax({
                url: launchframe.ajax_url,
                data: {
                    action: 'group_leaders_logout'
                },
                dataType: 'json'
            }).done(function(data) {
                location.assign($(logout_link).attr('href'));
            });
        });
    }
};